// Avisos de error de las pantallas: se muestran en shared/components/AvisosDeError.js.
export const EVENTO_ERROR = "aviso-error";

// Texto entendible para cualquier error; los de la base ya vienen traducidos (services/datos.js).
export function mensajeDeError(error) {
  if (error instanceof TypeError) return "No hay conexión con el servidor. Revisa tu internet e inténtalo de nuevo.";
  return error?.message || "Ocurrió un error inesperado.";
}

// Muestra el error en el aviso rojo de la pantalla.
export function avisarError(error) {
  window.dispatchEvent(new CustomEvent(EVENTO_ERROR, { detail: mensajeDeError(error) }));
}
